// Middleware exports - NO 'use client' directive here!
// Middleware runs in Edge Runtime, not in client browser

export { InsforgeMiddleware } from './InsforgeMiddleware';

export type { InsforgeMiddlewareConfig } from './InsforgeMiddleware';
